
      import Vue from 'vue';
      export default {
        scrollToTop: true,
        head() {
          return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
              },
              {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
              },
              {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Ghalin lotangan vandin charan" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Ghalin lotangan vandin charan" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Ghalin Lotangan Vandin Charan, ghalin lotangan vandin charan lyrics, Ghalin Lotangan, घालीन लोटांगण वंदीन चरण, ghalin lotangan vandin charan lyrics in marathi, ghalin lotangan lyrics, mantra pushpanjali'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Ghalin Lotangan Vandin Charan, Ghalin Lotangan Aarti, Marathi Aarti lyrics, devotional Aarti, spiritual prayers, Ghalin Lotangan , spiritual devotion, घालीन लोटांगण वंदीन चरण, ghalin lotangan vandin charan lyrics, ghalin lotangan vandin charan lyrics in english, ghalin lotangan vandin charan lyrics in marathi, ghalin lotangan lyrics, mantra pushpanjali'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/ghalin-lotangan.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/ghalin-lotangan.webp'
          },
            ],
          }
        },
      
          components: {
       },
       data() {
         return {
           title: 'Ghalin lotangan vandin charan | Ghalin lotangan- घालीन लोटांगण वंदीन चरण (घालीन लोटांगण)',
           langauageMarathi: true
         }
       },
       layout: 'detailsPage-withoutFooter',
   
       jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/ghalin-lotangan"
        },
        "headline": "Ghalin lotangan vandin charan - घालीन लोटांगण वंदीन चरण (घालीन लोटांगण)",
        "name" : "Ghalin lotangan vandin charan - Ghalin lotangan",
        "description": "Explore the full lyrics of Aarti 'Ghalin lotangan vandin charan' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/ghalin-lotangan.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
   
       computed: {
   
       },
       methods:{
       changeLanguage:function () {
         this.langauageMarathi = !this.langauageMarathi
       }
     }
   
     }
     
   